import type { AssetTreeNode } from "@/entities/asset-tree";

import { useCallback } from "react";

import { useReferentialConditionRatings } from "@/entities/referential/referential-condition-ratings";

import { getTreeNodeMarker } from "./asset-tree-node-marker.helper";

export const useTreeNodeMarker = () => {
  const { conditionRatings } = useReferentialConditionRatings();

  const getMarker = useCallback(
    (node: AssetTreeNode) => {
      return getTreeNodeMarker({ node, conditionRatings });
    },
    [conditionRatings]
  );

  return {
    getMarker,
  };
};
